import React, { useEffect, useState } from "react";
import { Button, Table, Tag, message, DatePicker, Space } from "antd";
import dayjs from "dayjs";
import API from "../../utils/api";
import Loader from "../../components/Loader";

const { RangePicker } = DatePicker;

const ManagerNEW = ({ isActive }) => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [dateRange, setDateRange] = useState([]);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 20,
    total: 0,
  });

  const status = "NEW";

  const fetchOrders = async (page = 1, pageSize = 20, useDate = false) => {
    setLoading(true);
    try {
      const params = { status, page, limit: pageSize };

      if (useDate && dateRange.length === 2) {
        params.startDate = dateRange[0].startOf("day").toISOString();
        params.endDate = dateRange[1].endOf("day").toISOString();
      }

      const res = await API.get("/manager/orders", { params });

      setOrders(res.data.orders || []);
      setPagination({
        current: page,
        pageSize,
        total: res.data.total || 0,
      });
    } catch (error) {
      console.error("Fetch error:", error);
      message.error("Failed to fetch manager orders");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (isActive) {
      fetchOrders(pagination.current, pagination.pageSize, false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isActive]);

  const columns = [
    {
      title: "Date",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (date) => dayjs(date).format("DD/MM/YYYY"),
    },
    {
      title: "Enrollment",
      dataIndex: "enrollment",
      key: "enrollment",
    },
    {
      title: "Manager",
      dataIndex: "manager",
      key: "manager",
    },
    {
      title: "Order ID",
      dataIndex: "orderId",
      key: "orderId",
    },
    {
      title: "Tracking ID",
      dataIndex: "trackingId",
      key: "trackingId",
      render: (text) => text || <span className="text-gray-400">N/A</span>,
    },
    {
      title: "Order Type",
      dataIndex: "orderType",
      key: "orderType",
      render: (text) => text || <span className="text-gray-400">N/A</span>,
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status) => (
        <Tag color="green" style={{ borderRadius: 999, padding: "0 12px" }}>
          {status}
        </Tag>
      ),
    },
  ];

  return loading ? (
    <Loader />
  ) : (
    <>
      <Space style={{ marginBottom: 16 }}>
        <RangePicker
          allowClear
          value={dateRange}
          onChange={(values) => {
            setDateRange(values || []);
            if (!values || values.length === 0) {
              // 🔹 When cleared → reload normal orders
              fetchOrders(1, pagination.pageSize, false);
            }
          }}
        />
        <Button
          type="primary"
          onClick={() => {
            if (dateRange.length === 2) {
              fetchOrders(1, pagination.pageSize, true);
            } else {
              message.warning("Please select a valid date range");
            }
          }}
        >
          Filter Orders
        </Button>
        <Button>Total Orders: {pagination.total}</Button>
      </Space>
      <Table
        bordered
        dataSource={orders}
        columns={columns}
        rowKey="_id"
        loading={loading}
        pagination={pagination}
        onChange={(pag) =>
          fetchOrders(
            pag.current,
            pag.pageSize,
            dateRange.length === 2 // keep filter active if selected
          )
        }
        scroll={{ x: "max-content" }}
      />
    </>
  );
};

export default ManagerNEW;
